import machinesFilterSlice from './machinesFilters-slice';

export const { setActiveMachinesFilters, resetActiveMachinesFiltersState, resetState } = machinesFilterSlice.actions;

export default machinesFilterSlice;
